import {
  getFormattedCart,
  getShippingAddress,
  getUpdatedItems
} from 'functions';
import {
  invert_nav,
  normal_nav_wrapper
} from 'Styles/modules/m-header.module.scss';
import { useMutation, useQuery } from '@apollo/client';

import { AppContext } from 'Context/AppContext';
import CartItem from 'Components/Cart/CartItem';
import CheckoutActionButton from 'Components/CheckoutActionButton';
import Container from 'Components/Container';
import GET_CART from 'Queries/GET_CART';
import Head from 'next/head';
import Layout from 'Components/Layout';
import Loading from 'Components/SpinnerLoader/Loading';
import MobileNav from 'Components/Headers/MobileNav';
import NavBackButton from 'Components/Headers/NavBackButton';
import ShippingAddress from 'Components/Cart/ShippingAddress';
import UPDATE_CART from 'Mutations/UPDATE_CART';
import classNames from 'classnames';
import { useContext } from 'react';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { v4 } from 'uuid';

const CHECKOUT_HREF = '/checkout/one-page-checkout';

const Cart = () => {
  const [cart, setCart] = useContext(AppContext);
  const [requestError, setRequestError] = useState(null);
  const router = useRouter();
  const productCount =
    null !== cart && Object.keys(cart).length ? cart.totalProductsCount : '';
  const products = cart?.products;

  // Get Cart Data.
  const { loading, error, data, refetch } = useQuery(GET_CART, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    onCompleted: () => {
      // Update cart in the localStorage.
      const updatedCart = getFormattedCart(data);
      localStorage.setItem('woo-next-cart', JSON.stringify(updatedCart));
      // Update cart data in React Context.
      setCart(updatedCart);
    },
    onError: (error) => {
      setRequestError(error);
    }
  });

  const [
    updateCart,
    {
      data: updateCartResponse,
      loading: updateCartProcessing,
      error: updateCartError
    }
  ] = useMutation(UPDATE_CART, {
    onCompleted: () => {
      refetch();
    },
    onError: (error) => {
      setRequestError(error);
    }
  });

  const handleRemoveProductClick = (event, cartKey, products) => {
    event.stopPropagation();
    if (products.length) {
      // By passing the newQty to 0 in updateCart Mutation, it will remove the item.
      const newQty = 0;
      const updatedItems = getUpdatedItems(products, newQty, cartKey);

      updateCart({
        variables: {
          input: {
            clientMutationId: v4(),
            items: updatedItems
          }
        }
      });
    }
  };

  const handleCheckoutClick = (e) => {
    e.preventDefault();
    let shippingAddress = getShippingAddress();
    if (shippingAddress == null) {
      alert('Vui lòng thêm địa chỉ giao hàng');
      return;
    }
    router.push(CHECKOUT_HREF);
  };

  return (
    <Layout className={classNames('cart', 'secondary-bg', 'lg:bg-white')}>
      {loading && <Loading />}
      <Head>
        <title>Giỏ hàng {productCount && `(${productCount})`}</title>
      </Head>
      <div className={classNames(normal_nav_wrapper)}>
        <NavBackButton className="lg:hidden" />
        <h1>Giỏ hàng{productCount && `(${productCount})`}</h1>
        <MobileNav className={invert_nav} />
      </div>
      <Container>
        {products?.length > 0 ? <ShippingAddress /> : null}
        {products?.length > 0 ? (
          products.map((item) => (
            <CartItem
              key={v4()}
              item={item}
              products={cart.products}
              updateCartProcessing={updateCartProcessing}
              updateCart={updateCart}
              handleRemoveProductClick={handleRemoveProductClick}
            />
          ))
        ) : (
          <div className="mt-20 block text-center">
            <span className="block">Chưa có sản phẩm trong giỏ hàng</span>
            <CheckoutActionButton onClick={() => router.push('/')}>
              Trở về trang chủ
            </CheckoutActionButton>
          </div>
        )}
      </Container>
      {products?.length > 0 ? (
        <div className={classNames(
          "cart-bottom fixed bottom-0 flex w-full justify-between border-t bg-slate-50 p-4 pb-6",
          "lg:mx-auto lg:relative lg:border lg:container lg:mt-4")}>
          <div className="total">
            <p className="text-sm">Tiền hàng</p>
            <p>
              <span className="font-medium text-red-500">{cart?.subtotal}</span>
            </p>
            <p className='text-sm italic'>{`+ ${cart?.shippingTotal} ship`}</p>
          </div>
          <button
            className="rounded bg-red-500 p-2 text-sm text-white"
            onClick={handleCheckoutClick}
          >{`Thanh toán (${productCount})`} <p className="font-medium text-white-500 font-semibold">{cart?.totalProductsPrice}</p></button>
        </div>
      ) : null}
    </Layout>
  );
};

export default Cart;
